import React, { useState } from "react";
import styled from "styled-components";
import { Storage } from "../../../../modules/Storage";
import { useAppDispatch } from "../../../../store";
import { setPaymentModal } from "../../../../store/slice/modal";

const productListClient = [
  {
    productId: 11,
    grade: "Free",
    price: 0,
    priceOriginal: 1000,
    priceText: "Free",
    priceTextUnit: "",
    productInfoHtml: JSON.stringify([
        "3 free chatbot conversations<br/>+",
        "Responses up to 300 characters per question<br/>+",
        "Information on suitable patent attorneys<br/>",
        "&nbsp;",
        "&nbsp;"
    ]),
    etc: "",
  },
  {
    productId: 12,
    grade: "1 Day",
    price: 1980,
    priceOriginal: 3000,
    priceText: "1,980",
    priceTextUnit: "KRW",
    productInfoHtml: JSON.stringify([
      "10 free chatbot conversations<br/>+",
      "Responses up to 500 characters per question<br/>+",
      "Consultation content storage<br/>+",
      "Information on suitable patent attorneys based on consultation"
    ]),
    etc: "",
  },
  {
    productId: 13,
    grade: "7 Day",
    price: 9900,
    priceOriginal: 29900,
    priceText: "9,900",
    priceTextUnit: "KRW",
    productInfoHtml: JSON.stringify([
      "20 free chatbot conversations per day<br/>+",
      "Responses up to 1000 characters per question<br/>+",
      "Consultation content storage<br/>+",
      "Information on suitable patent attorneys based on consultation"
    ]),
    etc: "",
  },
  {
    productId: 14,
    grade: "1 Month",
    price: 12900,
    priceOriginal: 33000,
    priceText: "12,900",
    priceTextUnit: "KRW/month",
    productInfoHtml: JSON.stringify([
      "30 free chatbot conversations per day<br/>+",
      "Responses up to 1000 characters per question<br/>+",
      "Consultation content storage<br/>+",
      "Information on suitable patent attorneys based on consultation"
    ]),
    etc: "",
  },
];

const productListAttorney = [
  {
    productId: 21,
    grade: "Personal Client",
    price: 3300,
    priceOriginal: 10000,
    priceText: "3,300",
    priceTextUnit: "KRW/Case",
    productInfoHtml: JSON.stringify([
    ]),
  },
  {
    productId: 22,
    grade: "Corporate Client",
    price: 9900,
    priceOriginal: 19900,
    priceText: "9,900",
    priceTextUnit: "KRW/Case",
    productInfoHtml: JSON.stringify([
    ]),
  },
  {
    productId: 23,
    grade: "Overseas Client",
    price: 12900,
    priceOriginal: 29900,
    priceText: "12,900",
    priceTextUnit: "KRW/Case",
    productInfoHtml: JSON.stringify([
    ]),
  },
];

const PriceTitle = styled.h2`
  @media (max-width: 1439px) {
    font-size: 1.88rem !important;
  }

  @media (max-width: 992px) {
    font-size: 2rem !important;
  }

  @media (max-width: 650px) {
    font-size: 1.7rem !important;
  }
`;

const Pricing = () => {
  const [activeGrid, setActiveGrid] = useState(null);
  const isAttorney = Storage.get("role")?.includes("attorney");
  const dispatch = useAppDispatch();
  const openPaymentModal = (product) => {
    console.log("openPaymentModal", product);
    dispatch(setPaymentModal({
      modalState: true,
      modalData: {
        productList: isAttorney ? productListAttorney : productListClient,
      },
    }));
  };

  return (
    <section className="wpo-pricing-section section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-5">
            <div className="wpo-section-title">
              <PriceTitle>Indip Service Cost Guide</PriceTitle>
            </div>
          </div>
        </div>
        <div className="pricing-grids clearfix">
          <p className="pricing-etc">(without VAT)</p>
          {isAttorney ? 
            <>
              {productListAttorney.map((product, index) => (
                <div
                  key={index}
                  className={`grid ${activeGrid === product.productId ? 'active' : ''}`}
                  onMouseEnter={() => setActiveGrid(product.productId)}
                  onMouseLeave={() => setActiveGrid(null)}
                  onClick={() => {
                    console.log("product clicked")
                    openPaymentModal(product);
                  }}
                >
                  <div className="type">
                    <h5 style={{ fontSize: "24px" }}>{product.grade}</h5>
                  </div>
                  <div className="pricing-header">
                    <div>
                      <h4 className="price">
                        {product.priceText}
                        <span>{product.priceTextUnit}</span>
                      </h4>
                      <p>{product.priceOriginal.toLocaleString()}</p>
                    </div>
                  </div>
                  <div className="pricing-body">
                    <ul>
                      {JSON.parse(product.productInfoHtml).map((item, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                      ))}
                    </ul>
                    {product.etc && <p dangerouslySetInnerHTML={{ __html: product.etc }}></p>}
                  </div>
                </div>
              ))}
            </>
          :
            <>
              {productListClient.map((product, index) => (
                <div
                  key={index}
                  className={`grid ${activeGrid === product.productId ? 'active' : ''}`}
                  onMouseEnter={() => setActiveGrid(product.productId)}
                  onMouseLeave={() => setActiveGrid(null)}
                  onClick={() => {
                    console.log("product clicked")
                    openPaymentModal(product);
                  }}
                >
                  <div className="type">
                    <h5 style={{ fontSize: "24px" }}>{product.grade}</h5>
                  </div>
                  <div className="pricing-header">
                    <div>
                      <h3 className="price">
                        {product.priceText}
                        <span>{product.priceTextUnit}</span>
                      </h3>
                      <p>{product.priceOriginal.toLocaleString()}</p>
                    </div>
                  </div>
                  <div className="pricing-body">
                    <ul>
                      {JSON.parse(product.productInfoHtml).map((item, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                      ))}
                    </ul>
                    {product.etc && <p dangerouslySetInnerHTML={{ __html: product.etc }}></p>}
                  </div>
                </div>
              ))}
            </>
          }
        </div>
      </div>
    </section>
  );

}

export default Pricing;